import 'lazysizes' /* Load the lazysizes librarie if not already done */

import { useContext } from 'react'

import { UserContext } from '@doist/marketist'

import cn from 'classnames'

/** While loading the image, displays a transparent pixel otherwise the failed icon will be shown */
const dummyImg = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='

type TodoistLazyImageProps = {
    src?: string
    webp?: string
    alt?: string
    className?: string
    lazyload?: boolean
    width?: number | string
    height?: number | string
    onClick?: () => void
}

export default function LazyImage({
    src,
    webp,
    className,
    alt = '',
    lazyload = true,
    ...rest
}: TodoistLazyImageProps) {
    const { webpSupport } = useContext(UserContext)
    const resolvedSrc = webp && webpSupport ? webp : src

    /** Do not lazy load inlined images */
    const shouldLazyload = lazyload && resolvedSrc && !resolvedSrc.startsWith('data:image')

    return (
        <img
            data-src={shouldLazyload ? resolvedSrc : null}
            src={shouldLazyload ? dummyImg : resolvedSrc}
            className={cn(className, shouldLazyload ? 'lazyload' : null)}
            alt={alt}
            {...rest}
        />
    )
}
